import classNames from 'classnames';
import Avatar from 'components/base/Avatar';
import { Message as MessageType } from './DataDefinitions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import ai from 'assets/img/icons/ai.png';
import ai from 'assets/img/th-each-ai/brain.png';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
    faFaceSmile,
    faPenToSquare,
    faReply,
    faShare,
    faTrash
} from '@fortawesome/free-solid-svg-icons';

import Button from 'components/base/Button';
import { Spinner } from 'react-bootstrap';
import React from 'react';

type MessageActionType = {
    icon: IconProp;
    label: string;
};

interface MessageProps {
    message: MessageType;
    showActions?: boolean;
}


interface MessageActionButtonsProps {
    actions: MessageActionType[];
    variant: 'sent' | 'received';
}


const actions: MessageActionType[] = [
    {
        icon: faTrash,
        label: 'Delete'
    },
    {
        icon: faReply,
        label: 'Reply'
    },
    {
        icon: faPenToSquare,
        label: 'Edit'
    },
    {
        icon: faShare,
        label: 'Share'
    },
    {
        icon: faFaceSmile,
        label: 'Emoji'
    }
];


const MessageActionButtons = ({
    actions,
    variant
}: MessageActionButtonsProps) => {
    return (
        <>
            <div className="d-sm-none hover-actions align-self-center me-2 start-0">
                <div className="bg-white rounded-pill d-flex align-items-center border border-300 px-2 actions">
                    {actions.map(action => (
                        <Button key={action.label} className="btn p-2" type="button">
                            <FontAwesomeIcon
                                icon={action.icon as IconProp}
                                className={classNames({
                                    'text-primary': variant === 'sent'
                                })}
                            />
                        </Button>
                    ))}
                </div>
            </div>
            <div className="d-none d-sm-flex">
                <div className="hover-actions position-relative align-self-center">
                    {actions.map(action => (
                        <Button key={action.label} className="fs-10 p-2" type="button">
                            <FontAwesomeIcon
                                icon={action.icon as IconProp}
                                className={classNames({
                                    'text-primary': variant === 'sent'
                                })}
                            />
                        </Button>
                    ))}
                </div>
            </div>
        </>
    );
};




const Message = ({ message, showActions = true }: MessageProps) => {

    const formatText = (text: string) => {
        return text.split('\n').map((line, index) => (
            <React.Fragment key={index}>
                {line}
                <br />
            </React.Fragment>
        ));
    };

    return (
        <div className="d-flex chat-message mt-1">
            <div className={classNames('d-flex flex-1', { 'justify-content-end': message.type === 'sent' })}>
                <div className={classNames('w-100', { 'w-xxl-75': showActions })}>
                    <div className={classNames('d-flex hover-actions-trigger', { 'flex-end-center': message.type === 'sent' })}>
                        {message.type === 'received' && (
                            <Avatar
                                src={ai}
                                size="xl"
                                className="me-1 pt-3 flex-shrink-0"
                            />

                        )}

                        {message.type === 'received' && message.asking && <Spinner className="mt-3" animation="grow" />}



                        {message.type === 'sent' && showActions && (
                            <MessageActionButtons actions={actions} variant="sent" />
                        )}

                        <div className={classNames('chat-message-content me-2', { received: message.type === 'received' })}>
                            <div className={classNames('p-3', { 'bg-200 rounded-5': message.type === 'sent', })}>
                                {message.message && <p className="mb-0 fs-7">{formatText(message.message)}</p>}
                            </div>
                        </div>

                    </div>
                    <div
                        className={classNames('d-flex gap-1 fs-10', {
                            'ms-7': message.type === 'received',
                            'justify-content-end': message.type === 'sent'
                        })}
                    >
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Message;
